import { Api } from '../API.js';

export default class Hours {
	
	static getHours = (globalState, setGlobalState, onSuccess, onFailure) => {
		Api(
			"getHoraires", 
			{},
			(data) => {
				onSuccess(data);
			},
			(idError) => {
				onFailure(idError);
			},
			globalState.token,
			globalState.setToken,
		);
	};

	static getNextOpeningHours(horaires) {
		// Keep only active and open schedules
		const activeOpen = horaires.filter(h => h.active === 1 && h.ouvert === 1);

		/**
		 * Builds a full UTC Date for a given schedule entry and reference week.
		 * @param {number} jourNum    - Day number (0=Mon … 6=Sun)
		 * @param {object} heureObj   - Time object from JSON ({ date: "..." })
		 * @param {object} refMonday  - Zurich parts of Monday 00:00 for the reference week
		 * @param {number} weekOffset - 0 for current week, 1 for next week
		 */
		function buildDate(jourNum, heureObj, refMonday, weekOffset = 0) {
			// Extract only the time portion from the JSON timestamp (UTC fields)
			const raw = new Date(heureObj.date?.split(".")[0]?.replace(/-/g, "/"));
			const h   = raw.getHours();
			const m   = raw.getMinutes();
			const s   = raw.getSeconds();

			// Compute the target Zurich calendar date
			const totalDays = jourNum + weekOffset * 7;
			const targetDate = new Date(refMonday.toLocaleString("en-US", {timeZone: "Europe/Zurich"}));
			targetDate.setDate(targetDate.getDate() + totalDays);
			targetDate.setHours(h);
			targetDate.setMinutes(m);
			targetDate.setSeconds(s);
			return targetDate;
		}

		// Current weekday and Monday of the current week, in Zurich time
		const now = new Date(new Date().toLocaleString("en-US", {timeZone: "Europe/Zurich"}));
		const mondayDayDiff = now.getDay() === 0 ? 6 : now.getDay() -1;
		let refMonday = new Date(now.toLocaleString("en-US", {timeZone: "Europe/Zurich"}));
		refMonday.setDate(refMonday.getDate() - mondayDayDiff);
		refMonday.setHours(0);
		refMonday.setMinutes(0);
		refMonday.setSeconds(0);

		for (let week = -1; week <= 1; week++) {
			// Build all openings/closings for this week, then sort by opening time
			const slots = activeOpen.map(h => {
				const opening = buildDate(h.jourDebut, h.heureDebut, refMonday, week);
				let   closing = buildDate(h.jourFin,   h.heureFin,   refMonday, week);

				// Fix: if closing <= opening, the slot crosses the end of the week (Sun→Mon)
				// → push closing 7 days forward
				if (closing <= opening) {
					closing.setDate(closing.getDate() + 7);
				}

				return { opening, closing };
			});

			// Sort by opening time to always return the nearest upcoming slot
			slots.sort((a, b) => a.opening - b.opening);

			for (const slot of slots) {
				if ((now >= slot.opening && now < slot.closing) || slot.opening > now) {
					return { opening: slot.opening, closing: slot.closing };
				}
			}
		}

		// Should never be reached if schedules cover the full week
		return null;
	}
}